import { render, staticRenderFns } from "./ProjectListNews.vue?vue&type=template&id=da3a4508&scoped=true"
import script from "./ProjectListNews.vue?vue&type=script&lang=js"
export * from "./ProjectListNews.vue?vue&type=script&lang=js"
import style0 from "./ProjectListNews.vue?vue&type=style&index=0&id=da3a4508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3a4508",
  null
  
)

export default component.exports